import '.g{display:flex;}.ssr-plugin'
import '.l{align-items:center;}.ssr-plugin'
import '.h{justify-content:center;}.ssr-plugin'
import '.k{flex-direction:column;}.ssr-plugin'
import '.bh{background-color:var(--shades-beige-100);}.ssr-plugin'
import '.bi{min-height:calc(100vh - 12rem);}.ssr-plugin'
import '.ab{align-items:stretch;}.ssr-plugin'
import '.bj{margin-top:2rem;}.ssr-plugin'
import '.ax{margin-bottom:5rem;}.ssr-plugin'
import '.aw{max-width:77.5rem;}.ssr-plugin'
import { ReactNode } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { DashboardNavBar } from '@app/components/blocks/navbar/dashboard/DashboardNavBar'
import { ClientOnly, Head } from '@based/sdk'

export const DashboardPageLayout = ({
  gap = '1rem',
  children,
}: {
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
}) => {
  const isMobile = useMediaQuery()
  return (
    <ClientOnly>
      <Head>
        <title>CrowdBuilding - dashboard</title>
      </Head>
      <div className="g l h k bh"
      >
        <DashboardNavBar />
        <div className="bi g k ab bj ax aw"
          style={{
            gap: gap,
            width: isMobile ? '100%' : '85%', // 12rem is padding + navbar height
            paddingInline: isMobile ? '1rem' : 0,}}
        >
          {children}
        </div>
      </div>
    </ClientOnly>
  )
}
